import styled, { css } from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

export const Container = styled.div<{ dashboard?: boolean }>`
    background: ${rgba(colorsPalettes.carbon[25], 0.5)};
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0 0 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
    ${({ dashboard }) =>
        dashboard &&
        css`
            height: auto;
            background: transparent;
            padding: 0;
            justify-content: space-between;
            ${Item} {
                padding: 0;
                margin-right: 0;
            }
        `}
`;
export const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    padding: 0;
    margin-right: 160px;
    @media (max-width: 1480px) {
        margin-right: 100px;
    }
    @media (max-width: 1280px) {
        margin-right: 80px;
    }
    ${SWReactIcons} {
        margin-left: 5px;
    }
`;
export const Text = styled.div`
    ${setFont({ $size: 14, $color: rgba(colorsPalettes.carbon[500], 0.6) })};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
`;

export const NumberContainer = styled.span`
    ${setFont({ $size: 20, $color: colorsPalettes.carbon[500] })}
`;
